import i18next from 'i18next';

i18next.addResources('es', 'noResults', {
  resultsNoFound: 'No encontramos resultados',
  mainText:
    'Pruebe ajustando su búsqueda y asegúrese de que todas las palabras estén escritas correctamente.',
  popular: 'También podría interesarte'
});
